import type { RouteRecordRaw } from 'vue-router'
import { PdfViewer as SharedPdfViewer } from '@h5-journey/components'

/** 聚合与预订链路路由（PLAN-H5-02）；页面标题按定稿 UI 在对应切片核对 */
export const aggregationRoutes: RouteRecordRaw[] = [
  {
    path: '/dynamicPackage/aggregation',
    name: 'DynamicPackageAggregation',
    component: () => import('../views/aggregation/index.vue'),
    meta: { title: '确认资源' }
  },
  {
    path: '/dynamicPackage/trainSelect',
    name: 'DynamicPackageTrainSelect',
    component: () => import('../views/trainSelect/index.vue'),
    meta: { title: '选择车次' }
  },
  {
    path: '/dynamicPackage/trainSelect/seat',
    name: 'DynamicPackageTrainSeat',
    component: () => import('../views/trainSelect/seat.vue'),
    meta: { title: '选择坐席' }
  },
  {
    path: '/dynamicPackage/booking',
    name: 'DynamicPackageBooking',
    component: () => import('../views/booking/index.vue'),
    meta: { title: '填写订单' }
  },
  {
    path: '/dynamicPackage/result',
    name: 'DynamicPackageResult',
    component: () => import('../views/result/index.vue'),
    meta: { title: '提交结果' }
  },
  {
    // PDF 预览（保险条款/投保须知等静态文件查看；复用 shared PdfViewer，参考 hotelResource 路由用法）
    // 保险须知/授权书不允许下载与复制链接，隐藏底部操作区
    path: '/dynamicPackage/pdfPreview',
    name: 'DynamicPackagePdfPreview',
    component: SharedPdfViewer,
    props: route => ({
      filePath: decodeURIComponent((route.query.filePath as string) || ''),
      title: (route.query.title as string) || '文件预览',
      showActions: false
    }),
    meta: { title: '文件预览' }
  }
]
